import { gql } from '@apollo/client';

import { DocumentFragment } from 'approot/shared/graphql/document/document.graphql';

export const assessmentWorksheetsFragment = gql`
  fragment AssessmentWorksheetsFragment on Assessment {
    id
    assessmentDoc {
      id
      documentType
      document {
        ...documentFragment
      }
    }
    basicAssessment {
      id
      documentType
      document {
        ...documentFragment
      }
    }
    selfAssessment {
      id
      documentType
      document {
        ...documentFragment
      }
    }
    summativeAssessment {
      id
      documentType
      document {
        ...documentFragment
      }
    }
    formativeAssessment {
      id
      documentType
      document {
        ...documentFragment
      }
    }
    answerSheet {
      id
      documentType
      document {
        ...documentFragment
      }
    }
  }
  ${DocumentFragment}
`;

export const ADD_SELF_ASSESSMENT = gql`
  mutation AddAssessmentSelfAssessment(
    $input: AddAssessmentContentDocumentInput!
  ) {
    addAssessmentSelfAssessment(input: $input) {
      id
      ...AssessmentWorksheetsFragment
    }
  }
  ${assessmentWorksheetsFragment}
`;

export const ADD_ASSESSMENT_ANSWER_SHEET = gql`
  mutation AddAssessmentAnswerSheet(
    $input: AddAssessmentContentDocumentInput!
  ) {
    addAssessmentAnswerSheet(input: $input) {
      id
      ...AssessmentWorksheetsFragment
    }
  }
  ${assessmentWorksheetsFragment}
`;

export const ADD_ASSESSMENT_WITH_DIFFERENTIATION = gql`
  mutation AddAssessmentWithDifferentiation(
    $input: AddAssessmentContentDocumentInput!
  ) {
    addAssessmentWithDifferentiation(input: $input) {
      id
      ...AssessmentWorksheetsFragment
    }
  }
  ${assessmentWorksheetsFragment}
`;

export const ADD_BASIC_ASSESSMENT = gql`
  mutation AddBasicAssessment($input: AddAssessmentContentDocumentInput!) {
    addBasicAssessment(input: $input) {
      id
      ...AssessmentWorksheetsFragment
    }
  }
  ${assessmentWorksheetsFragment}
`;

export const DELETE_BASIC_ASSESSMENT = gql`
  mutation DeleteBasicAssessment(
    $input: DeleteAssessmentContentDocumentInput!
  ) {
    deleteBasicAssessment(input: $input) {
      id
      ...AssessmentWorksheetsFragment
    }
  }
  ${assessmentWorksheetsFragment}
`;

export const DELETE_SELF_ASSESSMENT = gql`
  mutation DeleteAssessmentSelfAssessment(
    $input: DeleteAssessmentContentDocumentInput!
  ) {
    deleteAssessmentSelfAssessment(input: $input) {
      id
      ...AssessmentWorksheetsFragment
    }
  }
  ${assessmentWorksheetsFragment}
`;

export const DELETE_ASSESSMENT_WITH_DIFFERENTIATION = gql`
  mutation DeleteAssessmentWithDifferentiation(
    $input: DeleteAssessmentContentDocumentInput!
  ) {
    deleteAssessmentWithDifferentiation(input: $input) {
      id
      ...AssessmentWorksheetsFragment
    }
  }
  ${assessmentWorksheetsFragment}
`;

export const DELETE_ASSESSMENT_ANSWER_SHEET = gql`
  mutation DeleteAssessmentAnswerSheet(
    $input: DeleteAssessmentContentDocumentInput!
  ) {
    deleteAssessmentAnswerSheet(input: $input) {
      id
      ...AssessmentWorksheetsFragment
    }
  }
  ${assessmentWorksheetsFragment}
`;

export const ADD_SUMMATIVE_ASSESSMENT = gql`
  mutation AddSummativeAssessment($input: AddAssessmentContentDocumentInput!) {
    addSummativeAssessment(input: $input) {
      id
      ...AssessmentWorksheetsFragment
    }
  }
  ${assessmentWorksheetsFragment}
`;

export const DELETE_SUMMATIVE_ASSESSMENT = gql`
  mutation DeleteSummativeAssessment(
    $input: DeleteAssessmentContentDocumentInput!
  ) {
    deleteSummativeAssessment(input: $input) {
      id
      ...AssessmentWorksheetsFragment
    }
  }
  ${assessmentWorksheetsFragment}
`;

export const ADD_FORMATIVE_ASSESSMENT = gql`
  mutation AddFormativeAssessment($input: AddAssessmentContentDocumentInput!) {
    addFormativeAssessment(input: $input) {
      id
      ...AssessmentWorksheetsFragment
    }
  }
  ${assessmentWorksheetsFragment}
`;

export const DELETE_FORMATIVE_ASSESSMENT = gql`
  mutation DeleteFormativeAssessment(
    $input: DeleteAssessmentContentDocumentInput!
  ) {
    deleteFormativeAssessment(input: $input) {
      id
      ...AssessmentWorksheetsFragment
    }
  }
  ${assessmentWorksheetsFragment}
`;
